import { render, staticRenderFns } from "./Cameras.vue?vue&type=template&id=4857f9df"
import script from "./Cameras.vue?vue&type=script&lang=js"
export * from "./Cameras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports